// @flow

import getPinTypes from 'app/common/react/components/PinRep/utils/getPinTypes';
import { type Pin } from 'app/common/react/components/PinRep/types';
import { type Surface } from 'app/common/react/components/PinRep/core/PinRepConfiguration';

type GetPinTitleArgs = {|
  inChangeTitlesExp?: boolean,
  isGroupBoard?: boolean,
  pin: Pin,
  surface?: Surface,
|};

export default function getPinTitle({
  inChangeTitlesExp,
  isGroupBoard,
  pin,
  surface,
}: GetPinTitleArgs): string {
  const {
    buyable_product: buyableProduct,
    carousel_data: carouselData,
    grid_title: gridTitle,
    rich_summary: richSummary,
    title,
  } = pin;

  const { isOwnPin, isPromoted } = getPinTypes(pin);

  if (inChangeTitlesExp && !isPromoted) {
    return gridTitle || '';
  }

  // Don't return the title when it's your own pin. For carousel pins, title should be shown
  if (isOwnPin && !isGroupBoard && !carouselData && surface !== 'UserProfilePinGrid') {
    return '';
  }

  if (carouselData) {
    const { carousel_slots: carouselSlots = [], index } = carouselData;
    if (carouselSlots[index] && carouselSlots[index].title) {
      return carouselSlots[index].title.trim();
    }
  }

  const richTitle =
    richSummary && richSummary.type_name !== 'mobile application' && richSummary.display_name;

  const buyableTitle = buyableProduct && buyableProduct.title;

  // We always prefer displaying titles (native pin title) than rich titles.
  return title || richTitle || buyableTitle || gridTitle || '';
}
